import { useMemo } from "react";
import {
    MASTER_PRINT_FONT_BASE_URL,
} from "../../utils/designerUtils";
import PrintWizard from "./PrintWizard";
import PartMaterialView from "./PartsSectionPartMaterialView";
import PartSelectionView from "./PartsSectionPartSelectionView";
import MaterialColorView from "./PartsSectionMaterialColorView";

const PartsSection = ({
    stepMode = "part-material",
    partCards = [],
    partGroups = [],
    activePartKey = null,
    activeSectionKey = "",
    onChangeActiveSection,
    onSelectActivePart,
    onTogglePart,
    hideSearch = false,
    hotspotFilter = null,
    onClearHotspotFilter,
    activePartNode = null,
    activePartSelected = false,
    selectedMaterialId = null,
    selectedColor = null,
    materialOptions = [],
    onSelectMaterial,
    onFetchColors,
    onTogglePalette,
    paletteOpen = false,
    paletteLoading = false,
    availableColors = [],
    onSelectColor,
    onClearColor,
    onApplyBaseColor = null,
    baseColor = null,
    baseColorOptions = [],
    isDualPaintEnabled,
    onToggleDualPaint,
    canSublimate = false,
    isSublimated = false,
    onToggleSublimation,
    fullprints = [],
    selectedFullprint = null,
    onSelectFullprint,
    printLocations = [],
    categoryId = null,
    selectedPrints = {},
    activePrintKey = null,
    onSelectPrintLocation,
    printFilters = {},
    onSetPrintFilter,
    selectedPrint = null,
    selectedPrintsForLocation = [],
    printDetails = {},
    allColors = [],
    onAddPrint,
    onAddTextPrint,
    onAddImagePrint,
    onSelectPrintInstance,
    onClearPrint,
    onSetPrintMode,
    onSelectPrintText,
    onSelectPrintImage,
    onSelectPrintFont,
    onSelectPrintColor,
    onSetPrintAttr,
    onOpenLittleDesigns,
    littlePredesigns = [],
    littlePredesignsLoading = false,
    littlePredesignsLoaded = false,
    onPrepareLittleDesign,
    onApplyLittleDesign,
    fontBaseUrl = MASTER_PRINT_FONT_BASE_URL,
    printValidationErrors = [],
    printAdvisoryMessage = "",
    legalImageDisclaimer = "",
    garmentDefaultMaterialName = "",
    stripeWizard = null,
    onApplyStripeWizard = null,
    onClearStripeWizard = null,
    stripeDrawEditor = null,
    onSetStripeDrawEditor = null,
    stripeDrawingsBySide = null,
    customCutWizard = null,
    customCutEditor = null,
    onSetCustomCutEditor = null,
    customCutsBySide = null,
    customCutZones = null,
    customCutZoneColors = null,
    onSelectCustomCutZoneColor = null,
    onClearCustomCutZoneColor = null,
    onUndoCustomCut = null,
    onClearCustomCuts = null,
    customCutSummary = null,
    viewSide = "front",
    onUndoStripeStroke = null,
    onClearStripeDrawings = null,
    onPreviewPaintPart = null,
}) => {
    const currentStepMode = useMemo(() => {
        if (["part", "material", "part-material", "print"].includes(stepMode)) return stepMode;
        return "part-material";
    }, [stepMode]);

    if (currentStepMode === "part") {
        return (
            <PartSelectionView
                partCards={partCards}
                activePartKey={activePartKey}
                onSelectActivePart={onSelectActivePart}
                onTogglePart={onTogglePart}
            />
        );
    }

    if (currentStepMode === "part-material") {
        return (
            <PartMaterialView
                partCards={partCards}
                partGroups={partGroups}
                activePartKey={activePartKey}
                activeSectionKey={activeSectionKey}
                onChangeActiveSection={onChangeActiveSection}
                onSelectActivePart={onSelectActivePart}
                onTogglePart={onTogglePart}
                hideSearch={hideSearch}
                hotspotFilter={hotspotFilter}
                onClearHotspotFilter={onClearHotspotFilter}
                onSelectMaterial={onSelectMaterial}
                onFetchColors={onFetchColors}
                onTogglePalette={onTogglePalette}
                onSelectColor={onSelectColor}
                onClearColor={onClearColor}
                onApplyBaseColor={onApplyBaseColor}
                baseColor={baseColor}
                baseColorOptions={baseColorOptions}
                isDualPaintEnabled={isDualPaintEnabled}
                onToggleDualPaint={onToggleDualPaint}
                printLocations={printLocations}
                activePrintKey={activePrintKey}
                onSelectPrintLocation={onSelectPrintLocation}
                printFilters={printFilters}
                onSetPrintFilter={onSetPrintFilter}
                selectedPrint={selectedPrint}
                selectedPrintsForLocation={selectedPrintsForLocation}
                printDetails={printDetails}
                allColors={allColors}
                onAddPrint={onAddPrint}
                onSelectPrintInstance={onSelectPrintInstance}
                onClearPrint={onClearPrint}
                onSelectPrintText={onSelectPrintText}
                onSelectPrintImage={onSelectPrintImage}
                onSelectPrintFont={onSelectPrintFont}
                onSelectPrintColor={onSelectPrintColor}
                onSetPrintAttr={onSetPrintAttr}
                onOpenLittleDesigns={onOpenLittleDesigns}
                littlePredesigns={littlePredesigns}
                littlePredesignsLoading={littlePredesignsLoading}
                littlePredesignsLoaded={littlePredesignsLoaded}
                onPrepareLittleDesign={onPrepareLittleDesign}
                onApplyLittleDesign={onApplyLittleDesign}
                fontBaseUrl={fontBaseUrl}
                printValidationErrors={printValidationErrors}
                printAdvisoryMessage={printAdvisoryMessage}
                legalImageDisclaimer={legalImageDisclaimer}
                garmentDefaultMaterialName={garmentDefaultMaterialName}
                stripeWizard={stripeWizard}
                onApplyStripeWizard={onApplyStripeWizard}
                onClearStripeWizard={onClearStripeWizard}
                stripeDrawEditor={stripeDrawEditor}
                onSetStripeDrawEditor={onSetStripeDrawEditor}
                stripeDrawingsBySide={stripeDrawingsBySide}
                customCutWizard={customCutWizard}
                customCutEditor={customCutEditor}
                onSetCustomCutEditor={onSetCustomCutEditor}
                customCutsBySide={customCutsBySide}
                customCutZones={customCutZones}
                customCutZoneColors={customCutZoneColors}
                onSelectCustomCutZoneColor={onSelectCustomCutZoneColor}
                onClearCustomCutZoneColor={onClearCustomCutZoneColor}
                onUndoCustomCut={onUndoCustomCut}
                onClearCustomCuts={onClearCustomCuts}
                customCutSummary={customCutSummary}
                viewSide={viewSide}
                onUndoStripeStroke={onUndoStripeStroke}
                onClearStripeDrawings={onClearStripeDrawings}
                onPreviewPaintPart={onPreviewPaintPart}
            />
        );
    }

    if (currentStepMode === "material") {
        return (
            <MaterialColorView
                activePartNode={activePartNode}
                selectedKey={activePartSelected}
                selectedMaterialId={selectedMaterialId}
                selectedColor={selectedColor}
                materialOptions={materialOptions}
                onSelectMaterial={onSelectMaterial}
                onFetchColors={onFetchColors}
                onTogglePalette={onTogglePalette}
                paletteOpen={paletteOpen}
                paletteLoading={paletteLoading}
                availableColors={availableColors}
                onSelectColor={onSelectColor}
                canSublimate={canSublimate}
                isSublimated={isSublimated}
                onToggleSublimation={onToggleSublimation}
                fullprints={fullprints}
                selectedFullprint={selectedFullprint}
                onSelectFullprint={onSelectFullprint}
            />
        );
    }

    // Solo el wizard nuevo. El editor viejo (PrintView + PrintConfiguration) se retiró para no
    // duplicar (mostraba chips Pequeño/Mediano/Grande y "Usar estampado" que contradicen el flujo nuevo).
    return (
        <PrintWizard
            colors={allColors}
            predesigns={littlePredesigns}
            predesignsLoading={littlePredesignsLoading}
            printLocations={printLocations}
            categoryId={categoryId}
            selectedPrints={selectedPrints}
            onLoadPredesigns={onOpenLittleDesigns}
            onPrepareLittleDesign={onPrepareLittleDesign}
            onApplyLittleDesign={onApplyLittleDesign}
            onAddTextPrint={onAddTextPrint}
            onAddImagePrint={onAddImagePrint}
            onSelectPrintFont={onSelectPrintFont}
            onSelectPrintColor={onSelectPrintColor}
            onSetPrintAttr={onSetPrintAttr}
            onClearPrint={onClearPrint}
        />
    );
};

export default PartsSection;
